import { defineStore } from 'pinia';
import { ISearchResult } from '@/interfaces/search/ISearchResult';
import { computed, ref } from 'vue';

export const useStore = defineStore('store', () => {
  const oldQueryParams = ref({});
  const searchResult = ref<ISearchResult | null>(null);
  const originalSearchResult = ref<ISearchResult | null>(null);
  const viewItems = ref<ISearchResult>({ results: [], totalHits: 0 });
  const loading = ref<boolean>(true);
  const itemsPerPage = 15;
  const searchQuery = ref<string>('');
  const searchMatches = ref([]);
  const currentPage = ref(0);
  const mapVersion = ref<boolean>(true);
  const apiErrorMessage = ref<string | null>(null);
  const numTotalResult = computed(() => searchResult.value?.results.length ?? 0);
  const numResultWithCoordinates = ref(0);

  // Actions
  const sorting = ref({
    dataKey: null,
    descending: true,
  });

  const displayedResults = computed(() => {
    const start = currentPage.value * itemsPerPage;
    const end = start + itemsPerPage;
    var results = searchResult.value?.results;
    var paginatedResults = results?.slice(start, end);

    return paginatedResults;
  });

  return {
    oldQueryParams,
    searchResult,
    originalSearchResult,
    searchQuery,
    loading,
    viewItems,
    currentPage,
    searchMatches,
    itemsPerPage,
    sorting,
    displayedResults,
    mapVersion,
    apiErrorMessage,
    numTotalResult,
    numResultWithCoordinates
  }
})
